import { NotificationChannelTemplate } from './NotificationChannelTemplate';

export class SmsTemplate extends NotificationChannelTemplate {
}
